
export default function Target() {
  const targets = [
    'コンサルファーム出身者',
    'フリーランスコンサルタント',
    'PM経験者',
    'PMO経験者',
    'DX経験者',
    '戦略プロジェクト経験者'
  ];

  return (
    <section id="target" className="py-12 bg-[#0d1b2e]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
          こんな方におすすめ
        </h2>
        <div className="grid md:grid-cols-3 gap-3 max-w-4xl mx-auto">
          {targets.map((target, index) => (
            <div key={index} className="bg-[#1a2f4e] p-4 rounded-lg text-center hover:bg-[#1e3a5f] transition-colors border border-slate-700">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                <i className="ri-user-star-line text-3xl text-amber-400"></i>
              </div>
              <p className="font-semibold text-sm text-white">{target}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
